"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    simulate: function() {
        return simulate;
    }
});
const _weighted = /*#__PURE__*/ _interop_require_default(require("weighted"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const getPercentageAmount = (total, points)=>points / total * 100;
function simulate(items) {
    const groupIds = items.map((e)=>e.groupId);
    if (groupIds && groupIds.length > 1) {
        var _items_find;
        const total = items.reduce((prev, next)=>{
            var _next_model;
            return prev + (next === null || next === void 0 ? void 0 : (_next_model = next.model) === null || _next_model === void 0 ? void 0 : _next_model.points) || 1;
        }, 0);
        const weights = {};
        items.forEach((item)=>{
            var _item_model;
            const points = (item === null || item === void 0 ? void 0 : item.manager) ? 0 : (item === null || item === void 0 ? void 0 : (_item_model = item.model) === null || _item_model === void 0 ? void 0 : _item_model.points) || 1;
            weights[item.wrestlerId] = getPercentageAmount(total, points);
        });
        const winnerId = _weighted.default.select(weights);
        const winninggroupId = (_items_find = items.find((item)=>item.wrestlerId === winnerId)) === null || _items_find === void 0 ? void 0 : _items_find.groupId;
        items = items.map((item)=>{
            const winner = item.groupId === winninggroupId;
            item.winner = winner;
            return item;
        });
    }
    return items;
}
const _default = simulate;
